import { render, staticRenderFns } from "./QForm.vue?vue&type=template&id=31b4c892&"
import script from "./QForm.vue?vue&type=script&lang=js&"
export * from "./QForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports